import { IndicatorsUpdatePage } from '@pages';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import i18n from '@risksmart-app/i18n/src/i18n';
import type { RouteObject } from 'react-router';
import { ParamId } from 'src/routes/constants';

export const indicatorRoute: RouteObject = {
  path: `:${ParamId.Indicator}`,
  handle: {
    breadcrumbNode: {
      nodeType: Parent_Type_Enum.Indicator,
      paramName: ParamId.Indicator,
    },
  },
  children: [
    {
      path: '',
      element: <IndicatorsUpdatePage activeTabId={'details'} />,
    },
    {
      path: 'bands',
      handle: {
        title: () => i18n.t('bands.tab_title'),
      },
      element: <IndicatorsUpdatePage activeTabId={'bands'} />,
    },
    {
      path: 'results',
      handle: {
        title: () => i18n.t('indicator_results.tab_title'),
      },
      element: <IndicatorsUpdatePage activeTabId={'results'} />,
    },
    {
      // Kept flat (element, not a nested `children: [{ path: '' }]`) so it sits
      // at the same route depth as its sibling tabs. A deeper nesting rendered
      // the shared IndicatorsUpdatePage at a different tree position, forcing a
      // remount (and title refetch) when switching to/from this tab (CUS-150).
      path: 'linked-items',
      handle: {
        title: () => i18n.t('linkedItems.tab_title'),
      },
      element: <IndicatorsUpdatePage activeTabId={'linkedItems'} />,
    },
    {
      path: 'notification-history',
      handle: {
        title: () => i18n.t('notificationHistory.tab_title'),
      },
      element: <IndicatorsUpdatePage activeTabId={'notificationHistory'} />,
    },
  ],
};
